import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WicketAgreementSection} from '@tisa-group/models';
import {BehaviorSubject, Observable, of, filter, map, tap} from 'rxjs';
import {TISA_WICKET_V2_API_URL} from '../tisa-wicket.providers';

@Injectable({
  providedIn: 'root',
})
export class WicketAgreementsService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_V2_API_URL) readonly wicketV2ApiUrl: string | (() => string),
  ) {}

  agreementSections$ = new BehaviorSubject<Record<string, WicketAgreementSection[]>>({});

  getAgreementsSections(
    applicationSub?: string,
    context: 'user' | 'admin' = 'user',
  ): Observable<WicketAgreementSection[] | undefined> {
    const sub = applicationSub ?? 'default_sub';

    if (this.agreementSections$.getValue()[sub]) {
      return of(this.agreementSections$.getValue()[sub]);
    }
    const options = applicationSub
      ? {params: {'application[in]': [applicationSub]}}
      : undefined;

    return this.httpClient
      .get<WicketAgreementSection[]>(
        `${
          this.wicketV2ApiUrl instanceof Function
            ? this.wicketV2ApiUrl()
            : this.wicketV2ApiUrl
        }/agreements/groups`,
        options,
      )
      .pipe(
        filter(Boolean),
        map(sections =>
          context === 'admin'
            ? sections.filter(section => section.is_displayed_by_admin !== false)
            : sections.filter(section => section.is_displayed_by_user !== false),
        ),
        tap(sections =>
          this.agreementSections$.next({
            ...this.agreementSections$.getValue(),
            [sub]: sections,
          }),
        ),
      );
  }
}
